{
  "mineTitle": "Aking aktibidad",
  "mineLead": "Ang iyong mga pagpaparehistro at tiket, at ang mga ulat na ipinadala mo.",
  "myRegistrations": "Aking mga pagpaparehistro",
  "upcoming": "Paparating",
  "past": "Nakaraan",
  "noUpcoming": "Wala kang paparating na pagpaparehistro.",
  "noPast": "Wala pang nakaraang pagpaparehistro.",
  "findPrograms": "Maghanap ng programang bukas para sa pagpaparehistro",
  "signInForRegistrations": "Mag-sign in para makita ang iyong mga pagpaparehistro at tiket. Nakalista sa ibaba ang mga ulat na ipinadala mo mula sa teleponong ito.",
  "attended": "Dumalo",
  "waitlistNo": "Waitlist #{position}",
  "followingLead": "Ang mga post ng iyong sinusundan ang laman ng feed na \"Para sa iyo\", at maaabisuhan ka kapag nag-post sila.",
  "followingNone": "Wala ka pang sinusundan. Magsimula sa iyong barangay at sa mga opisinang madalas mong puntahan.",
  "municipalOffices": "Mga opisina ng munisipyo",
  "barangays": "Mga barangay",
  "barangay": "Barangay",
  "municipalOffice": "Opisina ng munisipyo",
  "topics": "Mga paksa",
  "followBarangayHint": "Mga post para sa mga residente ng mga barangay na ito, at mula sa kanilang opisina ng barangay.",
  "followTopicHint": "Mga post sa mga kategoryang ito, mula sa kahit anong opisina.",
  "pushTitle": "Mga abiso sa teleponong ito",
  "pushLead": "Mga bagong post mula sa iyong sinusundan, balita tungkol sa pagpaparehistro, at paalala isang araw bago ang aktibidad.",
  "pushTurnOff": "I-off ang mga abiso",
  "pushOff": "Naka-off ang mga abiso sa teleponong ito.",
  "notificationsLead": "Mga balita mula sa mga opisinang sinusundan mo at tungkol sa iyong mga pagpaparehistro.",
  "notificationsEmpty": "Wala pang abiso",
  "notificationsEmptyBody": "Sundan ang mga opisina at magparehistro sa mga programa; dito lalabas ang mga balita.",
  "markAllRead": "Markahang nabasa lahat",
  "unread": "Hindi pa nababasa",
  "officesLead": "Lahat ng opisina ng munisipyo at barangay na nagpo-post dito. Buksan ang isa para makita ang mga iskedyul at kontak nito.",
  "searchOffices": "Maghanap ng opisina o barangay",
  "noOffices": "Wala pang nakalistang opisina.",
  "noOfficeMatch": "Walang opisinang tugma sa hinahanap mo.",
  "allOffices": "Lahat ng opisina",
  "officeNotFound": "Hindi namin makita ang opisinang iyon.",
  "aboutOffice": "Tungkol dito",
  "contactTitle": "Kontak at oras ng opisina",
  "noContact": "Hindi pa nailalagay ng opisinang ito ang kanilang kontak.",
  "location": "Lokasyon",
  "officeHours": "Oras ng opisina",
  "phone": "Telepono",
  "otherContact": "Iba pang kontak",
  "officePosts": "Mga post at iskedyul",
  "officeNoPosts": "Walang kasalukuyang post",
  "officeNoPostsBody": "Walang kasalukuyang iskedyul, programa o anunsiyo ang opisinang ito.",
  "officeNoPostsFollow": "Walang kasalukuyang post ang opisinang ito. Sundan ito para maabisuhan ka kapag nag-post sila."
}
